module.exports = __webpack_public_path__ + "img/GS_Profiles-Phirwa Phirwa.85b2264d.png";